import styled, { css } from 'styled-components';
import { breakpointMap, theme } from '../../../theme';
import { StyledContentCardProps } from './ContentCard';

const contentCardWidths = {
  small: 164,
  large: 216,
};

export const ContentCardBase = styled.article<StyledContentCardProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  border: 1px solid ${theme.colors.neutrals.solidGrays[6]};
  border-radius: ${theme.borderRadius.default};

  transition: border-color 200ms ease-in;

  ${({ size }) =>
    breakpointMap(
      size,
      (cardSize) => css`
        max-width: ${contentCardWidths[cardSize]}px;
        > * {
          max-width: ${contentCardWidths[cardSize]}px;
        }
      `
    )};

  &:hover {
    border-color: ${theme.colors.neutrals.solidGrays[7]};
  }
`;
